import IncomeGapsFilter from "./IncomeGapsFilter";
import MonthlyEarningsGapsItem from "./IncomeGapsItem";

const IncomeGaps = () => {
  return (
    <>
      <IncomeGapsFilter />
      <MonthlyEarningsGapsItem />
    </>
  );
};

export default IncomeGaps;
